export default __webpack_public_path__ + "static/media/EasyToUse.ae3d58fc.png";